export enum EventTypes {
  // CRUD operations
  New,
  Create,
  Update,
  Delete,

  // Navigational
  Edit, // edit view
  List, // list view
  Select,

  // User Management
  Roles, // roles view

  Sort,
  Table,
  CardList,
  // TODO Should probably split these up by feature
  Clear,
  Validate,

  TextFilter,
}
